import { Link } from 'react-router-dom';
import * as React from 'react';
import { UitkCard, UitkCardContentSection, UitkCardLink } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import { useStores } from '../../../../utils/hooks';
import { onClickScrollToTarget } from '../../../../helpers/smooth-scroll';
export var CategoryTileCard = function (_a) {
  var _b, _c;
  var category = _a.category,
    index = _a.index;
  var analytics = useStores().analytics;
  var handleCategoryClick = function (category) {
    onClickScrollToTarget({
      scrollTo: 0
    });
    if (category.clientSideAnalytics) {
      analytics.trackEvent(category.clientSideAnalytics.referrerId, category.clientSideAnalytics.linkName, analytics.omnitureData);
    }
  };
  var disabledClass = category.enabled === false ? 'disabled-card' : '';
  var primary = category.primary;
  return React.createElement(UitkCard, {
    key: "".concat(primary.text, "-category-tile-card-").concat(index),
    "data-testid": 'category-tile-card',
    border: true
  }, React.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R3_2
  }, React.createElement(UitkImage, {
    className: disabledClass,
    alt: (_b = category.image) === null || _b === void 0 ? void 0 : _b.description,
    src: (_c = category.image) === null || _c === void 0 ? void 0 : _c.url
  })), React.createElement(UitkCardContentSection, {
    padded: ['inlineend', 'inlinestart', 'blockstart']
  }, React.createElement(UitkSpacing, {
    padding: {
      blockstart: 'one',
      blockend: 'two'
    }
  }, React.createElement(UitkText, {
    className: disabledClass,
    size: 400,
    weight: "medium",
    align: "left"
  }, primary.text))), React.createElement(UitkCardContentSection, {
    padded: ['inlineend', 'inlinestart', 'blockend']
  }, React.createElement(UitkSpacing, {
    padding: {
      blockend: 'one'
    }
  }, category.secondaryMessage ? React.createElement(UitkText, {
    size: 200,
    weight: "regular",
    align: "left"
  }, category.secondaryMessage) : null)), category.enabled && React.createElement(UitkCardLink, null, React.createElement(Link, {
    onClick: handleCategoryClick.bind(null, category),
    to: category.link || ''
  }, primary.text)));
};